export const Bases = () => {
    return (
        <article className="legal">
            <h1>Bases de la Promoción</h1>
            <p>
                Las presentes bases corresponden a la promoción “LAS CUATRO ESTACIONES DEL SABOR”
                llevada a cabo por la sociedad Rijk Zwaan Ibérica, S.A., domiciliada en Ctra Viator
                PJ.Mamí, S/N | 04120 Almería |- España, con CIF A04065231 (en adelante, «Rijk
                Zwaan»), en las que se recogen las condiciones de la promoción y participación en la
                misma. Las bases de esta promoción se encuentran a disposición de los usuarios en{' '}
                <a href="http://www.lascuatroestacionesdelsabor.es">
                    www.lascuatroestacionesdelsabor.es
                </a>
            </p>

            <h2>PRIMERA.- Empresa organizadora</h2>
            <p>
                Rijk Zwaan Ibérica, S.A. organiza la presente promoción en las fechas indicadas en
                la siguiente estipulación.
            </p>

            <h2>SEGUNDA.- Periodo de participación</h2>
            <p>
                El período de participación comprenderá desde el día 30 de septiembre de 2025 hasta
                el día 2 de octubre de 2025
            </p>

            <h2>TERCERA.- Legitimación para participar</h2>
            <ul>
                <li>
                    <strong>3.1 Legitimación.</strong> Podrán participar en la presente promoción
                    las personas físicas mayores de 18 años con residencia legal en España y Andorra
                    que hayan aceptado las presentes bases y cada uno de sus términos y condiciones.
                </li>
                <li>
                    <strong>3.2 Exclusiones.</strong> No podrán participar los empleados de Rijk
                    Zwaan, de las agencias de publicidad, agencias de promociones o de cualesquiera
                    otras empresas relacionadas con esta promoción, así como sus familiares hasta el
                    primer grado de consanguinidad y/o afinidad.
                </li>
            </ul>

            <h2>CUARTA.- Ámbito y naturaleza</h2>
            <p>
                La participación en la presente promoción tendrá su desarrollo en todo el territorio
                nacional y Andorra. La participación en la misma tiene carácter gratuito.
            </p>

            <h2>QUINTA.- Descripción del premio</h2>
            <p>
                El premio consistirá en el regalo de 1 Air Fryer modelo. Se sortearán un total de 3
                unidades.
            </p>
            <p>
                Rijk Zwaan gestionará el envío del premio hasta la dirección que indique el
                agraciado.
            </p>

            <h2>SEXTA.- Mecánica de participación</h2>
            <p>
                Desde el 30 de septiembre al 2 de octubre de 2025, ambos días inclusive, los
                usuarios que deseen participar en el sorteo deberán rellenar un formulario web
                alojado en
                <a href="http://www.lascuatroestacionesdelsabor.es">
                    www.lascuatroestacionesdelsabor.es
                </a>{' '}
                y escanear un mínimo de 1 de código QR, que encontrarán en los diferentes estands de
                las empresas asociadas a la promoción en Fruit Attraction 2025 (pabellones 3,7 y 9).
            </p>
            <p>
                Las participaciones se obtienen escaneando los diferentes códigos QR repartidos
                entre las 20 empresas asociadas a la promoción.
            </p>
            <p>
                El número máximo participaciones es de 21 (20 a través de escanear los códigos QR
                más 1 participación extra por haberlos escaneado todos). Los participantes también
                podrán participar en el sorteo a través de las redes sociales de las empresas
                asociadas a la promo-ción que publiquen dicha información. Igualmente, desde las
                cuentas oficiales de las redes sociales de Sweet Palermo, se podrá acceder al enlace
                correspondiente para obtener una participación más.
            </p>
            <p>
                El día 7 de noviembre de 2025, Rijk Zwaan, de manera totalmente aleatoria, sorteará
                a través de la AppSorteos, y de entre todos los formularios correctamente
                rellenados, el ganador.
            </p>
            <p>
                La entrega efectiva del regalo quedará condicionada a que los participantes cumplan
                con las condiciones especificadas en las presentes bases y a la veracidad y
                exactitud de los datos facilitados por este a Rijk Zwaan. El regalo no será
                susceptible de cambio.
            </p>
            <p>Rijk Zwaan se reserva todos los derechos de esta promoción.</p>

            <h2>SÉPTIMA.- Comunicación del ganador</h2>
            <p>
                Rijk Zwaan comunicará al ganador, mediante, llamada o correo electrónico, el premio
                obtenido, con el fin de confirmar sus datos personales (nombre, apellidos y
                dirección), así como detallarle las condiciones de entrega del premio, sin coste
                alguno para el ganador.
            </p>
        </article>
    )
}
